var _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExercise05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 0.386719,
    width: 350,
    height: 233,
    fill: "#2E4491"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 181.977,
    y: 121.207,
    width: 132.355,
    height: 9.70212,
    rx: 2,
    fill: "#FFC7C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.332 128.909V123.207C314.332 122.102 313.436 121.207 312.332 121.207H309.852C309.637 121.207 309.446 121.235 309.241 121.3C298.899 124.563 251.318 130.909 220.234 130.909H312.332C313.436 130.909 314.332 130.014 314.332 128.909Z",
    fill: "#EFA7A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232.508,
    y: 120.91,
    width: 31.29,
    height: 10.3042,
    rx: 1,
    fill: "#CF7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.781 92.1953C205.781 91.0907 206.677 90.1953 207.781 90.1953H217.893C218.998 90.1953 219.893 91.0907 219.893 92.1953V159.926C219.893 161.03 218.998 161.926 217.893 161.926H207.781C206.677 161.926 205.781 161.03 205.781 159.926V92.1953Z",
    fill: "#347E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.892 159.926V100.891L208.83 161.926H217.892C218.997 161.926 219.892 161.031 219.892 159.926Z",
    fill: "#245F6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.67 100.133C191.67 99.0282 192.565 98.1328 193.67 98.1328H205.782V153.993H193.67C192.565 153.993 191.67 153.097 191.67 151.993V100.133Z",
    fill: "#347E8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.527 98.1328H302.639C303.744 98.1328 304.639 99.0282 304.639 100.133V151.993C304.639 153.097 303.744 153.993 302.639 153.993H290.527V98.1328Z",
    fill: "#347E8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.416 92.1953C276.416 91.0907 277.311 90.1953 278.416 90.1953H288.528C289.632 90.1953 290.528 91.0907 290.528 92.1953V159.926C290.528 161.03 289.632 161.926 288.528 161.926H278.416C277.311 161.926 276.416 161.03 276.416 159.926V92.1953Z",
    fill: "#347E8D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.783 153.987V103.441L194.721 153.987H205.783Z",
    fill: "#245F6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.416 159.926V100.891L287.479 161.926H278.416C277.312 161.926 276.416 161.031 276.416 159.926Z",
    fill: "#245F6B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.529 153.987V103.441L301.592 153.987H290.529Z",
    fill: "#245F6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise05);
export default __webpack_public_path__ + "static/media/exercise_05.f83328f5aa7995b84643b7bc6e1987d0.svg";
export { ForwardRef as ReactComponent };